import React from 'react';

import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

import TableCell from './TableCell';
import TableRow from './TableRow';

interface TableCollapsedRowProps {
    children: React.ReactNode;
    appendedChild?: { childCellType: 'head' | 'body'; childCellData: string | number };
    collapsedRowChildData?: Record<string, any>[];
    additionalClasses?: string;
}

const TableCollapsedRow: React.FC<TableCollapsedRowProps> = (props) => {
    const { children, additionalClasses, appendedChild, collapsedRowChildData } = props;

    const [isCollapsed, setIsCollapsed] = React.useState(false);

    const styles = React.useMemo(
        () => ({
            collapsingIcon: {
                position: 'absolute' as 'absolute',
                left: '0',
            },
            icon: {
                height: '1rem',
                width: '1rem',
            },
        }),
        []
    );

    return (
        <React.Fragment>
            <tr className={`${additionalClasses} is-clickable`} onClick={() => setIsCollapsed(!isCollapsed)}>
                {appendedChild && (
                    <TableCell type={appendedChild.childCellType} additionalClasses="is-relative" draggable={false}>
                        <span className="icon is-absolute" style={styles.collapsingIcon}>
                            {isCollapsed ? <FaAngleUp style={styles.icon} /> : <FaAngleDown style={styles.icon} />}
                        </span>

                        {appendedChild.childCellData}
                    </TableCell>
                )}

                {children}
            </tr>

            {isCollapsed && (
                <React.Fragment>
                    {collapsedRowChildData && collapsedRowChildData.length > 0 ? (
                        <React.Fragment>
                            {collapsedRowChildData.map((row) => (
                                <TableRow key={row.classificationCode}>
                                    <TableCell type="body" draggable={false}>
                                        {row.classificationCode}
                                    </TableCell>
                                    <TableCell type="body" draggable={false}>
                                        {row.classificationTitle ? row.classificationTitle.fr : 'N/A'}
                                    </TableCell>
                                    <TableCell type="body" draggable={false}>
                                        {row.classificationUnit}
                                    </TableCell>
                                    <TableCell type="body" draggable={false} additionalClasses="has-text-right">
                                        {row.totalExclVat.toLocaleString('fr-FR', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}{' '}
                                        €
                                    </TableCell>
                                </TableRow>
                            ))}
                        </React.Fragment>
                    ) : (
                        <TableRow>
                            <TableCell type="body" additionalClasses="is-hidden-mobile">
                                <div className="th-wrap is-numeric">{null}</div>
                            </TableCell>
                            <TableCell type="body" additionalClasses="is-hidden-mobile">
                                <div className="th-wrap">No data</div>
                            </TableCell>
                            <TableCell type="body" additionalClasses="is-hidden-mobile">
                                <div className="th-wrap is-numeric">{null}</div>
                            </TableCell>
                            <TableCell type="body" additionalClasses="is-hidden-mobile">
                                <div className="th-wrap is-numeric">{null}</div>
                            </TableCell>
                        </TableRow>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default TableCollapsedRow;
